import { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { GMB_MEDIA_EMAIL, NEW_TAB_ATTRIBUTES, EXTERNAL_PATHS } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import Button from 'src/common/components/ButtonDS22';
import styles from './MediaFooter.module.scss';

const MediaFooter: FC = () => {
  const [t] = useTranslation('press-page');

  return (
    <PitchPageLayout backgroundColor="midnight01">
      <div className={styles.root}>
        <div className={styles.title}>
          <Typography
            type="h3"
            size="display-5"
            weight="semibold"
            sizeFromBreakpointM="display-4"
          >
            {t('footer--title')}
          </Typography>
        </div>
        <div className={styles.text}>
          <Typography type="p" size="body-xl">
            {t('footer--text')}
          </Typography>
        </div>
        <div className={styles.button}>
          <Button
            href={`${EXTERNAL_PATHS.JOURNAL}company-news/`}
            variant="tertiary-white"
            type="link"
            fitWidth="m"
            {...NEW_TAB_ATTRIBUTES}
          >
            {t('footer--button')}
          </Button>
        </div>
        <div className={styles.text}>
          <Typography type="p" size="body-xl">
            <Trans
              t={t}
              i18nKey="inquiry--text"
              values={{ mediaEmail: GMB_MEDIA_EMAIL }}
              components={{
                emailLink: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                  <a
                    className={styles.link}
                    href={`mailto:${GMB_MEDIA_EMAIL}`}
                    {...NEW_TAB_ATTRIBUTES}
                  />
                ),
              }}
            />
          </Typography>
        </div>
      </div>
    </PitchPageLayout>
  );
};

export default MediaFooter;
